(function () {
  'use strict';

  angular.module('app').service('TourInventoryModalService', TourInventoryModalService);

  TourInventoryModalService.$inject = ['ModalService'];

  function TourInventoryModalService(ModalService) {
    var service = {
      openTourInventoryModal: openTourInventoryModal,
    };

    return service;

    ///////////////////////

    function openTourInventoryModal(item, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/tour-inventories/modals/tour-inventory-modal.html',
        controller: TourInventoryModalCtrl,
        controllerAs: 'vm',
        inputs: {
          item: item,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      TourInventoryModalCtrl.$inject = ['$element', 'item', 'successCallback'];
    }

    function TourInventoryModalCtrl($element, item, successCallback) {
      var vm = this;

      vm.item = item;

      vm.modalTitle = 'UPDATE_INVENTORY';

      vm.onInventorySaved = onInventorySaved;

      function onInventorySaved() {
        $element.modal('hide');
        successCallback();
      }
    }
  }
})();
